const TWO_DECIMALS = 2;
const NO_DECIMALS = 0;

export const getDecimalsToDisplayFromPrice = (priceValue) => {
  if (!Number(priceValue)) {
    return NO_DECIMALS;
  }

  const sanitizedValue = Number(priceValue);
  const isWholeNumber = sanitizedValue % 1 === 0;
  return isWholeNumber ? NO_DECIMALS : TWO_DECIMALS;
};

export const getFractionalCentsDigits = (priceValue) => {
  return priceValue?.toString().split('.')[1]?.length || 2;
};

export const getDollarValueAsCents = (priceValue) => {
  let priceValueAsCents = (priceValue * 100).toFixed(1);
  if (priceValueAsCents.endsWith('0')) {
    priceValueAsCents = (priceValue * 100).toFixed(0);
  }
  return priceValueAsCents;
};
